module.exports = __webpack_public_path__ + "static/media/logo-appsco-unab.5f09073e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sponsorsLogos/logo-appsco-unab.png
// module id = 341
// module chunks = 0